/**
 * GraphQL Query
 * EC在庫画面
 */

/**
 * EC在庫一覧
 */
export const GRAPH_QL_QUERY_EC_STOCK_LIST =
`
query {
  ecStockListItems ( ? ) {
    edges {
      node {
        stockType
        site { 
          code 
          name
          type
        }
        sku {
          uuid 
          product { 
            code
            uuid
            name
          } 
          color { 
            code
            name
          }
          size { 
            code
            name
          }
          code
          name
        }
        ecStockDistr { 
          amount 
        }
        ecStock { 
          standard
          registered
          allocated
          ordered
          exported
          qty
        }
      }
    }
    totalCount
  }
}
`

/**
 * EC在庫アラート一覧
 */
export const GRAPH_QL_QUERY_STOCK_ALERT_LIST =
`
query {
  ecStockAlertItems ( ? ) {
    edges {
      node {
        ecStockAlert {
          id
          site { 
            code 
            name
          }
        }
        id
        uuid
        no
        productId
        stockType
        alertType
        alertValue
        isEnabled
        note
        createdAt
        updatedAt
      }
    }
    totalCount
  }
}
`

/**
 * EC在庫アラート詳細
 */
export const GRAPH_QL_QUERY_STOCK_ALERT_DETAIL =
`
query {
  ecStockAlertItems ( ? ) {
    edges {
      node {
        ecStockAlert {
          site { 
            code 
          }
        }
        alerteds {
          statusCode
        }
        uuid
        no
        productId
        stockType
        alertType
        alertValue
        isEnabled
        note
      }
    }
    totalCount
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/stock.js